module.exports = "<div class=\"fact-cell-header\" ng-bind=\"$ctrl.header\"></div>\n<div class=\"fact-cell-fact\" ng-bind=\"$ctrl.fact\"></div>";